// extracted by mini-css-extract-plugin
export default {"CookieDisclaimerPage":"CookieDisclaimerPage_CookieDisclaimerPage__qB0Yc","Disclaimer":"CookieDisclaimerPage_Disclaimer__I9oBZ"};